import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import Wizard from "@/pages/Wizard";
import TrackTicket from "@/pages/TrackTicket";
import PuntoLimpio from "@/pages/PuntoLimpio";
import PuntoLimpioEstadisticas from "@/pages/PuntoLimpioEstadisticas";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import TecnicoAyuntamientoDashboard from "@/pages/TecnicoAyuntamientoDashboard";
import PuntoLimpioStaffDashboard from "@/pages/PuntoLimpioStaffDashboard";
import AvisoLegal from "@/pages/AvisoLegal";
import Privacidad from "@/pages/Privacidad";
import Cookies from "@/pages/Cookies";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solicitud" element={<Wizard />} />
            <Route path="/consultar" element={<TrackTicket />} />
            <Route path="/punto-limpio" element={<PuntoLimpio />} />
            <Route path="/punto-limpio/estadisticas" element={<PuntoLimpioEstadisticas />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/ayuntamiento" element={<TecnicoAyuntamientoDashboard />} />
            <Route path="/admin/punto-limpio" element={<PuntoLimpioStaffDashboard />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/cookies" element={<Cookies />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster />
    </div>
  );
}

export default App;
